import {
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { removeCartBucket as removeCartBucketAPI, RemoveCartBucketParameter } from "@waytek/Services/CartService";

type Parameter = {
    cartId: string;
    bucket: string;
} & HasOnSuccess<any>;

type Props = {
    apiParameter: RemoveCartBucketParameter;
    apiResult: any;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginRemoveCartBucket: HandlerType = props => {
    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });
    props.dispatch({
        type: "Pages/Cart/BeginClearCart",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        cartId: props.parameter.cartId,
        bucket: props.parameter.bucket,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await removeCartBucketAPI(props.apiParameter);
};

export const LoadCart: HandlerType = props => {
    props.dispatch(
        loadCurrentCart({
            getPromotions: true,
            onSuccess: () => {
                props.dispatch({
                    type: "Context/CompleteUpdatingCart",
                });
                props.dispatch({
                    type: "Pages/Cart/CompleteClearCart",
                });
            },
        }),
    );
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginRemoveCartBucket,
    PopulateApiParameter,
    SendDataToApi,
    LoadCart,
    ExecuteOnSuccessCallback,
];

const removeCartBucket = createHandlerChainRunner(chain, "RemoveCartBucket");
export default removeCartBucket;
